import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigBase } from '../../../../models/config-base.model';
import { NotificationManager } from '../../../../managers/notification.manager';
import { CaseConfig } from '../../../../models/case-config.model';
import { CaseConfigService } from '../../../../services/case-config.service';
import { LexbeCase } from '../../../../models/case.model';
import { CasesService } from '../../../../services/cases.service';

@Component({
    selector: 'lex-case-config',
    templateUrl: './case-config.component.html',
    styleUrls: ['./case-config.component.scss'],
    standalone: false
})
export class CaseConfigComponent {

	public lexbeCase: LexbeCase;
	public caseConfigs: CaseConfig[] = [];

	constructor(
		private caseService: CasesService,
		private caseConfigService: CaseConfigService,
		private notificationManager: NotificationManager,
		@Inject(MAT_DIALOG_DATA) private inputCase: LexbeCase
	) {
		this.lexbeCase = this.inputCase;
		this.caseConfigService.getCaseConfigs(this.lexbeCase.caseId)
			.subscribe((data: CaseConfig[]) => {
				this.caseConfigs = data;
		})
	}

	saveConfig(config: ConfigBase): void {
		const caseConfig: CaseConfig = {
			caseId: this.lexbeCase.caseId,
			configTypeId: config.configTypeId,
			type: config.type,
			value: config.value
		};
		this.caseConfigService.updateCaseConfig(caseConfig).subscribe(() => {
			this.notificationManager.displaySnackBarMessage({
				message: 'Case configuration updated successfully.'
			});
		});
	}
}
